var _path, _path2, _path3, _path4, _path5, _circle, _ellipse, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredIntWire2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7648 17L31.7648 11C31.7648 10.4477 31.3171 10 30.7648 10H5.21484C4.66256 10 4.21484 10.4477 4.21484 11V28C4.21484 28.5523 4.66256 29 5.21485 29H16.193L24.579 29",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7656 10V10C10.7656 13.3137 8.07933 16 4.76563 16L3.76562 16",
    stroke: "#20242E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7656 10V10C24.7656 13.866 27.8996 17 31.7656 17V17",
    stroke: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7656 29V29C10.7656 25.6863 8.07933 23 4.76562 23H3.76562",
    stroke: "#20242E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2656 15C16.8849 15 15.7656 15.8954 15.7656 17C15.7656 18.1046 16.599 19 18.2656 19C19.9323 19 20.7656 19.8954 20.7656 21C20.7656 22.1046 19.6463 23 18.2656 23M18.2656 15C19.191 15 19.9989 15.4022 20.4312 16M18.2656 15V14M18.2656 23L18.2656 24M18.2656 23C17.3403 23 16.5324 22.5978 16.1001 22",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7656,
    cy: 24,
    r: 5,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.7656,
    cy: 24,
    rx: 2,
    ry: 5,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7656 24H35.7656",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredIntWire2);
export default __webpack_public_path__ + "static/media/ic-colored-int-wire2.4925b1aaac8f4bd93f5ab6114fa0a9fa.svg";
export { ForwardRef as ReactComponent };